import type { IconName } from '@bookora/ui';

/**
 * The device column's text.
 *
 * `GET /auth/sessions` now names the device in Persian itself («کروم روی
 * ویندوز», «سافاری روی آیفون», and «دستگاه ناشناخته» for anything it cannot
 * read). Sessions opened before that change still carry the raw user agent —
 * «curl/8.7.1», «Mozilla/5.0 (…)» — which means nothing to a clinic, so those
 * keep reading as an unknown device, with the raw string in the cell's title
 * for whoever needs it.
 */
export function deviceLabel(name: string | null | undefined): string {
  const text = (name ?? '').trim();
  if (text === '') return 'دستگاه ناشناخته';
  if (/[\u0600-\u06FF]/.test(text)) return text;
  if (/[/()]|mozilla|curl|okhttp|dart|python|axios|postman/i.test(text)) return 'دستگاه ناشناخته';
  return text;
}

/**
 * The picture beside the name, from the server's `deviceKind`. A phone and a
 * tablet share the handheld icon; a desktop gets the monitor; an unknown
 * device gets none rather than a guess — a wrong icon beside «دستگاه
 * ناشناخته» would say more than anyone knows.
 */
export function deviceIcon(kind: string | null | undefined): IconName | null {
  switch (kind) {
    case 'MOBILE':
    case 'TABLET':
      return 'mobile';
    case 'DESKTOP':
      return 'monitor';
    default:
      return null;
  }
}

/** The kind in words, for the icon's accessible name. */
export function deviceKindLabel(kind: string | null | undefined): string | null {
  switch (kind) {
    case 'MOBILE':
      return 'گوشی';
    case 'TABLET':
      return 'تبلت';
    case 'DESKTOP':
      return 'رایانه';
    default:
      return null;
  }
}
